// Tests: src/app/migrations/migration-v15-to-v16.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V15 → V16
 *
 * Punktart-Umbau: `type` wird von "<nummer>_<beschreibung>" auf die reine
 * Nummer als String ("6_Tiefbohrung" -> "6") umgestellt. Nummer, Beschreibung
 * und Symbol-SVG kommen kuenftig als Single Source aus der Punktarten-Liste
 * (DB `bpweb-listen`); `type` ist nur noch der stabile Nummer-Schluessel.
 *
 * Upgrade leitet die Nummer aus den fuehrenden Ziffern ab. Downgrade stellt den
 * historischen Voll-String aus der eingefrorenen Map `NUMMER_TO_TYPE` wieder her
 * (reversibel, Muster wie migration-v8-to-v9). Generiert via
 * tools/build-punktarten.mjs (tools/punktarten-type-map.generated.json) als
 * eingefrorener Snapshot des Stands vor der Migration — bewusst NICHT importiert,
 * damit spaetere Listen-Edits diese historische Migration nicht ruckwirkend
 * veraendern.
 */
const NUMMER_TO_TYPE: Record<string, string> = {
  '1': '1_Weisergrube_ohne_Bodenanalyse',
  '2': '2_Weisergrube_mit_Bodenanalyse',
  '3': '3_Bodengrube_ohne_Bodenanalyse',
  '4': '4_Bodengrube_mit_Bodenanalyse',
  '5': '5_Humusprobe',
  '6': '6_Tiefbohrung',
  '7': '7_Moorpunkt',
  '8': '8_GW_hoeher_1',
  '9': '9_GW_hoeher_2',
  '10': '10_GW_tiefer_1',
  '11': '11_GW_tiefer_2',
  '12': '12_SW_stärker',
  '13': '13_SW_geringer',
  '14': '14_kleinfl_Entwässerung',
  '15': '15_Kleingewaesser',
  '16': '16_Einsprengung_andere_Bodenform',
  '17': '17_Nährkraft_höher_1',
  '18': '18_Nährkraft_höher_2',
  '19': '19_Nährkraft_geringer_1',
  '20': '20_Nährkraft_geringer_2',
  '21': '21_kleinfl_karbonatisch',
  '23': '23_kleinfl_organisch',
  '24': '24_kleinfl_mineralisch',
  '25': '25_kleinfl_quellig',
  '27': '27_fMu',
  '28': '28_iMu',
  '29': '29_mMu',
  '30': '30_tMu',
  '31': '31_nMM',
  '32': '32_fMM',
  '33': '33_iMM',
  '34': '34_mMM',
  '35': '35_tMM',
  '36': '36_nMo',
  '37': '37_fMo',
  '38': '38_iMo',
  '39': '39_mMo',
  '40': '40_tMo',
  '41': '41_nRM',
  '42': '42_fRM',
  '43': '43_iRM',
  '44': '44_mRM',
  '45': '45_tRM',
  '46': '46_nRo',
  '47': '47_fRo',
  '48': '48_iRo',
  '49': '49_mRo',
  '50': '50_tRo',
  '51': '51_iMgRo',
  '52': '52_mMgRo',
  '53': '53_tMgRo',
  '54': '54_iHuRo',
  '55': '55_mHuRo',
  '56': '56_tHuRo',
  '57': '57_Rohboden',
  '58': '58_iHMo',
  '59': '59_mHMo',
  '60': '60_tHMo',
  '61': '61_iHRM',
  '62': '62_mHRM',
  '63': '63_tHRM',
  '64': '64_iHRo',
  '65': '65_mHRo',
  '66': '66_tHRo',
  '67': '67_pos_Abweichung',
  '68': '68_neg_Abweichung',
  '69': '69_mMuHMo',
  '70': '70_kleinfl_abweichende_Humusform',
  '83': '83_stark_verhagerungsgefährdet',
  '84': '84_mäßig_verhagerungsgefährdet',
  '85': '85_schwach_verhagerungsgefährdet',
  '90': '90_GWundNährkraft_höher_1',
  '91': '91_GW_höher_1_Nährkraft_höher_2',
  '93': '93_GW_tiefer_1_Nährkraft_höher_1',
  '94': '94_GW_tiefer_2_Nährkraft_tiefer_1',
  '95': '95_GW_tiefer_1_Nährkraft_tiefer_1',
  '96': '96_GW_tiefer_1_Nährkraft_tiefer_2',
  '97': '97_GW_höher_1_Nährkraft_tiefer_1',
  '98': '98_GW_höher_2_Nährkraft_tiefer_1',
  '99': '99_GW_tiefer_2_Nährkraft_höher_1',
  '100': '100_GW_höher_2_Nährkraft_tiefer_2',
  '101': '101_GW_tiefer_2_Nährkraft_tiefer_2',
  '102': '102_GW_höher_2_Nährkraft_höher_1',
  '103': '103_GW_höher_2_Nährkraft_höher_2',
  '104': '104_GW_höher_1_Nährkraft_tiefer_2',
  '112': '112_SW_stärker_2',
  '113': '113_SW_geringer_2',
  '120': '120_Substratfeuchte_1_feuchter',
  '121': '121_Substratfeuchte_2_feuchter',
  '122': '122_Substratfeuchte_3_feuchter',
  '123': '123_Substratfeuchte_1_trockener',
  '124': '124_Substratfeuchte_2_trockener',
  '125': '125_Substratfeuchte_3_trockener',
  '130': '130_Nährkraft_höher_1_SW_stärker_1',
  '131': '131_Nährkraft_höher_1_SW_geringer_1',
  '132': '132_Nährkraft_höher_1_SW_stärker_2',
  '133': '133_Nährkraft_höher_1_SW_geringer_2',
  '134': '134_Nährkraft_höher_2_SW_stärker_1',
  '135': '135_Nährkraft_höher_2_SW_geringer_1',
  '136': '136_Nährkraft_höher_2_SW_stärker_2',
  '137': '137_Nährkraft_höher_2_SW_geringer_2',
  '138': '138_Nährkraft_geringer_1_SW_stärker_1',
  '139': '139_Nährkraft_geringer_1_SW_geringer_1',
  '140': '140_Nährkraft_geringer_1_SW_stärker_2',
  '141': '141_Nährkraft_geringer_1_SW_geringer_2',
  '142': '142_Nährkraft_geringer_2_SW_stärker_1',
  '143': '143_Nährkraft_geringer_2_SW_geringer_1',
  '144': '144_Nährkraft_geringer_2_SW_stärker_2',
  '145': '145_Nährkraft_geringer_2_SW_geringer_2',
  '146': '146_karbonatisch_SW_stärker_1',
  '147': '147_karbonatisch_SW_geringer_1',
  '148': '148_karbonatisch_SW_stärker_2',
  '149': '149_karbonatisch_SW_geringer_2',
  '150': '150_Sonderstandort',
  '9990': '9990_Infopunkt',
  '9991': '9991_Halbtiefbohrung_mit_Protokoll',
  '9998': '9998_Halbtiefbohrung',
  '9999': '9999_Grenzaufschluss',
};

export const migrationV15ToV16: MigrationDefinition = {
  fromVersion: 15,
  toVersion: 16,

  upgrade(doc: any): any {
    // Nur Voll-Strings (mit '_') umsetzen; bereits numerische Typen bleiben.
    if (typeof doc.type === 'string' && doc.type.includes('_')) {
      const n = parseInt(doc.type, 10);
      if (Number.isFinite(n)) doc.type = String(n);
    }
    doc.version = 16;
    return doc;
  },

  downgrade(doc: any): any {
    const full = NUMMER_TO_TYPE[String(doc.type)];
    if (full) doc.type = full;
    doc.version = 15;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade kann eine Punktart-Nummer, die nicht im historischen Katalog steht, nicht in ihren Voll-String zurueckgewandelt werden (type bleibt die Nummer).'
  ]
};
